import {
  Side,
  front,
  top,
  right,
  bottom,
  left,
  back
} from 'src/constants/sides'
import { Box3, Quaternion } from 'three'

export interface Translation {
  position?: [number, number, number]
  matrixAutoUpdate?: boolean
  matrix?: [number, number, number, number, number, number, number, number, number, number, number, number, number, number, number, number] // prettier-ignore
  quaternion?: Quaternion // | [number, number, number, number]
  rotation?: [number, number, number]
}

export const getSidePosition = (
  side: Side,
  boundings: Box3
): [number, number, number] => {
  const { min, max } = boundings
  const x = (max.x + min.x) / 2
  const y = (max.y + min.y) / 2
  const z = (max.z + min.z) / 2
  switch (side) {
    case top:
      return [x, max.y, z]
    case bottom:
      return [x, min.y, z]
    case right:
      return [max.x, y, z]
    // return {
    //   matrixAutoUpdate: false,
    //   matrix: [0, 1, 0, max.x, -1, 0, 0, y, 0, 0, 1, z, 0, 0, 0, 1] //).setPosition(new THREE.Vector3(max.x, y, z))
    // }
    case left:
      return [min.x, y, z]
    // return {
    //   matrixAutoUpdate: false,
    //   matrix: [0, -1, 0, min.x, -1, 0, 0, y, 0, 0, -1, z, 0, 0, 0, 1]
    //   //).setPosition(new THREE.Vector3(min.x, y, z))
    // }
    case front:
      return [x, y, max.z]

    case back:
      return [x, y, min.z]
  }
}

export const getSideTranslation = (
  side: Side,
  boundings: Box3
): Translation => {
  const { min, max } = boundings
  const x = (max.x + min.x) / 2
  const y = (max.y + min.y) / 2
  const z = (max.z + min.z) / 2
  switch (side) {
    case top:
      return { position: [x, max.y, z] }
    case bottom:
      return { position: [x, min.y, z], quaternion: new Quaternion(0, 0, 1, 0) }
    case right:
      return {
        matrixAutoUpdate: false,
        matrix: [0, 1, 0, max.x, -1, 0, 0, y, 0, 0, 1, z, 0, 0, 0, 1] //).setPosition(new THREE.Vector3(max.x, y, z))
      }
    case left:
      return {
        matrixAutoUpdate: false,
        matrix: [0, -1, 0, min.x, -1, 0, 0, y, 0, 0, -1, z, 0, 0, 0, 1]
        //).setPosition(new THREE.Vector3(min.x, y, z))
      }
    case front:
      return {
        position: [x, y, max.z],
        quaternion: new Quaternion(0.5, -0.5, -0.5, 0.5)
      }
    case back:
      return {
        position: [x, y, min.z],
        quaternion: new Quaternion(-0.5, 0.5, -0.5, 0.5)
      }
  }
}

type RotateSide = (arg: { [key in 'from' | 'to']: Side }) => any

export const rotateSide: RotateSide = ({ from, to }) => {
  switch ([from, to].toString()) {
    /** FRONT */
    case [front, front].toString():
      return {}
    case [top, left].toString():
    case [right, left].toString():
    case [bottom, left].toString():
    case [left, right].toString():
    case [back, back].toString():
      return front
    /** TOP */
    case [front, top].toString():
    case [top, front].toString():
    case [right, top].toString():
    case [bottom, back].toString():
    case [left, top].toString():
    case [back, top].toString():
      return top
    /** RIGHT */
    case [front, right].toString():
    case [top, bottom].toString():
    case [right, front].toString():
    case [bottom, top].toString():
    case [left, back].toString():
    case [back, left].toString():
      return right
    /** BOTTOM */
    case [front, bottom].toString():
    case [top, back].toString():
    case [right, bottom].toString():
    case [bottom, front].toString():
    case [left, bottom].toString():
    case [back, bottom].toString():
      return bottom
    /** LEFT */
    case [front, left].toString():
    case [top, top].toString():
    case [right, back].toString():
    case [bottom, bottom].toString():
    case [left, front].toString():
    case [back, right].toString():
      return left
    /** BACK */
    case [front, back].toString():
    case [top, right].toString():
    case [right, right].toString():
    case [bottom, right].toString():
    case [left, left].toString():
    case [back, front].toString():
      return back
    default:
      throw console.warn(
        `getGlobalPlateSide went wrong with params: parentSide = ${from} & selfSide = ${to}`
      )
  }
}
